import { APIMailMerge, APICreateDataSheets, APIMergeOrderForm,GetFlgFromID, GetPanels } from './Api'
import {nf } from './helpers/numbers'
import CreateDetailHTML from './CreateDetailHTML'
import pdf_config from './configs/pdf_configs'
import pdf_pages from './pdf_field_mappings'

// PDF Mail Merge Helper Functions to Tidy up CalcResults.js
// Getting far too large and unmanageable - This module deals purely 
// With anything related to front end prep / Presentations for PDF Mail Merge
let panels =[]

const  getIllustrions = (sellprice, document_fee, deposit_amount) => {

    var lv = sellprice + document_fee - deposit_amount
    var flds = []
    var multi = [0.01394,0.01728,0.01918,0.02189,0.02599,0.03288]
    var mnths = [120,84,72,60,48,36]
    for(var i=0; i<6; i++) {
        var mp = lv * multi[i]
        var ap = 'N/A'
        var sv = 'N/A'
        var tp = mp * mnths[i]
        if(i!=0 ) {
            ap = mp - flds[0].mp
            sv = flds[0].tp - tp 
        }
        flds[i] ={mp,df: document_fee,ap,tp,sv }
    }
    return flds
}

export const PDFMergePage = async (page, state) =>  {
    const flg_id = state.flg_id

    var yr1_bill_savings_text = "Saving " + nf(state.yr1_elec_savings,0) + "% off your electricity bill"
    if(state.yr1_gas_savings && state.yr1_gas_savings > 0 )
    yr1_bill_savings_text += "     Saving " + nf(state.yr1_gas_savings,0) + "% off your gas bill"

   /* system_cost_7day: state.system_cost_7day,
    system_cost_discount: state.system_cost_discount,
    system_cost_discount450: state.system_cost_discount450,
    system_cost_nooffer: state.system_cost_nooffer,*/

    //const average_annual_roi_30 = "Average Annual ROI " +   nf((nf(state.avg_total,2) / nf(state.system_cost_30day,2)) * 100,0 ) + '%'
    //const average_annual_roi_7day = "Average Annual ROI " + nf((nf(state.avg_total,2) / getOfferSystemCost(state) ) * 100,0 ) + '%'
    //const average_annual_roi_priv = "Average Annual ROI " + nf((nf(state.avg_total,2) / nf(state.system_cost_privilege,2))*100,0 ) + '%'

    // Added by BB May need to be removed and replaced with 3 lines above 16/2/2022 
    const average_annual_roi_30 = "Average Annual ROI " +   nf((nf(state.avg_total,2) / nf((state.sellprice??0),2)) * 100,0 ) + '%'
    const average_annual_roi_7day = "Average Annual ROI " + nf((nf(state.avg_total,2) / nf((state.sellprice??0).toString(),2)) * 100,0 ) + '%'
    const average_annual_roi_priv = "Average Annual ROI " + nf((nf(state.avg_total,2) / nf((state.sellprice??0).toString(),2))*100,0 ) + '%'


    
    const numyears = state.savings.length


    var net_contribution = ""
    var net_contribution_text = ""
    var avg_monthly_savings = ""
    var illi = []
    var loan = 0
    var sellprice = 0
    let deposit_amount = state.deposit_amount
    if(state.financeterm > 1 && typeof state.financeoption !== "undefined" && state.financeoption.description != "Cash" && state.fin_monthlypayment) {
        let monthly_payment = ((state.fin_monthlypayment??0.00) * 1).toFixed(2);  // Ensure it is a number
        net_contribution = "£" + monthly_payment  //average_monthly_net_contribution
        net_contribution_text = "Monthly Payments from"

        if((state.financeoption??null) && (state.financeoption.pay_later_month??0) > 0 )
            net_contribution_text = "Monthly Buy Now Pay Later Payments from"
        illi = getIllustrions(state.sellprice, 0, deposit_amount)
        loan = state.sellprice - state.deposit_amount 

    }else {
        // Create some base line savings
        deposit_amount = (state.sellprice*0.1)
        illi = getIllustrions(state.sellprice, 0, deposit_amount )
        loan = state.sellprice - (state.sellprice*0.1)
    }
        var monthly_savings = (state.totals.tot_capped_accumulative_savings/state.savings.length/12)??0.00
        monthly_savings= monthly_savings.toFixed(2)
        avg_monthly_savings = `Average Monthly\nSavings of\n£ ${monthly_savings}`
    

    var data = {
        savings: [... state.savings],
        has_voltageoptimser: state.has_voltageoptimser,
        has_iboost: state.has_iboost, 
        has_smart_thermostat: state.has_smart_thermostat,
        has_smart_energy: state.has_smart_energy, 
        yr1_batteryandsolar_benefit: state.yr1_batteryandsolar_benefit,
        yr1_smartproduct_benefit: state.yr1_smartproduct_benefit,
        yr1_smartexport_benefit: state.yr1_smartexport_benefit,
        yr1_smarttariff_benefit: 0, // state.yr1_smarttariff_benefit,
        avg_savings: state.avg_savings,
        avg_anual_roi: state.avg_anual_roi,
        yr1_total:  state.yr1_total ,
        yr1_elec_savings: state.yr1_elec_savings ,
        yr1_gas_savings:  state.yr1_gas_savings ,
        yr1_bill_savings_text: yr1_bill_savings_text,
        avg_batteryandsolar_benefit: state.avg_batteryandsolar_benefit,
        avg_smartproduct_benefit: state.avg_smartproduct_benefit,
        avg_smartexport_benefit: state.avg_smartexport_benefit,
        avg_smarttariff_benefit: state.avg_smarttariff_benefit,
        avg_total: state.avg_total,
        calculating: false,
        currency: state.currency,
        financeoption: state.financeoption,
        total_system_cost: state.total_system_cost,
        total_benefit: state.total_benefit,
        total_profit: state.total_profit,
        average_monthly_net_contribution: state.average_monthly_net_contribution,
        calcterm: numyears ,
        with_xyears_time: 'In ' + numyears + " Years Time",
        without_xyears_time: 'In ' + numyears + " Years Time",
        average_monthly_with_solar: (state.savings[0].elec_savings/12),
        average_monthly_without_solar: (state.savings[0].electric_cost/12),
        average_xyears_with_solar: (state.savings[numyears-1].elec_savings/12),
        average_xyears_without_solar: (state.savings[numyears-1].electric_cost/12),
        full_name: state.full_name,
        address: state.address,
        line_items: state.line_items,
        system_cost_30day: state.sellprice,         //state.system_cost_30day,
        system_cost_privilege: state.sellprice,     // state.system_cost_privilege,
        system_cost_7day: state.sellprice,          // state.system_cost_7day,
        system_cost_discount: state.sellprice,      // state.system_cost_discount,
        system_cost_discount450: state.total_system_cost,   //state.system_cost_discount450,
        system_cost_nooffer: state.sellprice,
        offerid: state.offerid,
        average_annual_roi_30,  
        average_annual_roi_7day,  
        average_annual_roi_priv,  
        totals: state.totals,
        net_contribution: net_contribution,
        net_contribution_text: net_contribution_text,
        avg_monthly_savings: avg_monthly_savings,
        loan: loan,
        deposit_amount: deposit_amount,
        sellprice: state.sellprice,
        offgrid_system: state.offgrid_system,
        mp1: illi[0].mp, df1: illi[0].df,ap1: illi[0].ap, tp1: illi[0].tp, sv1: illi[0].sv,
        mp2: illi[1].mp, df2: illi[1].df,ap2: illi[1].ap, tp2: illi[1].tp, sv2: illi[1].sv,
        mp3: illi[2].mp, df3: illi[2].df,ap3: illi[2].ap, tp3: illi[2].tp, sv3: illi[2].sv,
        mp4: illi[3].mp, df4: illi[3].df,ap4: illi[3].ap, tp4: illi[3].tp, sv4: illi[3].sv,
        mp5: illi[4].mp, df5: illi[4].df,ap5: illi[4].ap, tp5: illi[4].tp, sv5: illi[4].sv,
        mp6: illi[5].mp, df6: illi[5].df,ap6: illi[5].ap, tp6: illi[5].tp, sv6: illi[5].sv
    }

    await APIMailMerge(flg_id,page, data)
}



const getOfferSystemCost = (state) => {
    var systemcost = state.total_system_cost    // Default position
    //return systemcost;
    switch(state.offerid ) {
        case '7 Day Offer 1':
            systemcost = state.system_cost_7day
            break;
        case '7 Day Offer 2':
            systemcost = state.system_cost_7day         
            break;
        case '7 Day Offer 3':
                systemcost = state.system_cost_discount     
                break;
        case '7 Day Offer 4':
            systemcost =  state.system_cost_discount450  
            break;
        case '7 Day Offer 5':
            systemcost = state.system_cost_nooffer  
            break;
    }
    return systemcost
} 

export const PDFProcessDataTables = async (page, state, pdf_page, ancillarycosts, batterys, filelist = []) => {
            // This is where we do our main X Year PDF craetion
        // Tables are a nightmare to deal with - so in our server
        // We create an HTML file version of what we want. Then we
        // Use Google Puppeteer to create a headless browser and open th e HTML file
        // Then print PDF from the browser to create the file.
        // Not the neatest soltion but one widely used and it works! 
        // (Setting up puppeteer on CentOS bit of a pain though)
        // We send to Our Server with the /filewriter api. Was going to write a separte server to deal
        // With All PDF work (Might Still Break it out but its one more process that needs to run!) 
        
        // Get dfata ready for what we need to create the tables
//console.log('*** PDFProcessDataTables ***')
//console.log(state)
//console.log('****************************')
        var invstring = ""
        var hybridcnt = 0
        var stringcnt = 0
        var offgridcnt = 0        
        var data = {
            savings: [... state.savings],
            has_voltageoptimser: state.has_voltageoptimser,
            has_iboost: state.has_iboost, 
            has_smart_thermostat: state.has_smart_thermostat,
            has_smart_energy: false, // state.has_smart_energy, 
            yr1_batteryandsolar_benefit: state.yr1_batteryandsolar_benefit,
            yr1_smartproduct_benefit: state.yr1_smartproduct_benefit,
            yr1_smartexport_benefit: state.yr1_smartexport_benefit,
            yr1_smarttariff_benefit: 0, //state.yr1_smarttariff_benefit,
            avg_savings: state.avg_savings,
            avg_anual_roi: state.avg_anual_roi,
            yr1_total:  state.yr1_total ,
            yr1_elec_savings: state.yr1_elec_savings ,
            yr1_gas_savings:  state.yr1_gas_savings ,
            avg_batteryandsolar_benefit: state.avg_batteryandsolar_benefit,
            avg_smartproduct_benefit: state.avg_smartproduct_benefit,
            avg_smartexport_benefit: state.avg_smartexport_benefit,
            avg_smarttariff_benefit: state.avg_smarttariff_benefit,
            avg_total: state.avg_total,
            currency: state.currency,
            financeoption: state.financeoption,
            total_system_cost: state.total_system_cost,
            total_benefit: state.total_benefit,
            total_profit: state.total_profit,
            average_monthly_net_contribution: state.average_monthly_net_contribution,
            calcterm: state.calcterm,
            full_name: state.full_name,
            address: state.address,
            latlng: state.latlng,
            totals: JSON.parse(JSON.stringify(state.totals)),

        }
        const accontroller = state.accontroller
        // we can only fit 15 on a page at a time (Split so it looks ok)
        // So we loop round and create as many pages as we need to satisfy our need.
        const flg_id = state.flg_id
        const numrows = state.calcterm
        const num_pages = (parseInt ((numrows/pdf_config.years_per_page)+0.5))
        const elecconsumption = state.elecconsumption
        var page_no = page
        var ifrom = 1
        var ito = pdf_config.years_per_page
        let qty_integration_trays_new = 0
        let qty_integration_trays_exs = 0
        let qty_integration_trays_exs_stripped =0 

        for(var i=1; i<=num_pages; i++) {
            const html_page='page' + page_no + ".html"
            //const pdf_page='page' + page_no + ".pdf"
            // Craete the HTML Version of the 25 (X Year) Year Data Table.
            const html = await CreateDetailHTML(data, ifrom, ito)
            // Send to the API for HTML file creation and PDF file creation.
            await APICreateDataSheets(flg_id,html,html_page,pdf_page,"landscape")
            page_no++
            ifrom += pdf_config.years_per_page
            ito += pdf_config.years_per_page
            if(ito > numrows) ito = numrows
        }

        // Create the Customer Order Form here if we can
        // Create the data to mailmerg
        // Get Out FLG Data

        const ret = await GetFlgFromID(flg_id);
        if(typeof ret.payload === "Undefined")
            return;
        const flg = ret.payload
        const panelArrays = state.panelArrays
        const now = new Date()
        const order_date = now.getDate() + '/' + (now.getMonth()+1).toString().padStart(2,'0') + '/' + now.getFullYear()
        // Formats if we need them: format: then 'Uppercase', 'Lowercase', 'Currency'
        // We can also add font: 'fredokaone', 'opensans', 'feltthat' if we want one of the Presenter fonts
        var phone = flg.phone1.toString()
        if(phone.substr(0,1) !== "0" && phone.length > 8)
            phone = "0" + phone

        var phone2 = flg.phone2
        if(phone2 && typeof phone2 !== "undefined")
            phone2 = phone2.toString()
        if(phone2.substr(0,1)!== "0" && phone2.length > 8)
                phone2 = "0" + phone2

        var mobile = ""
        var home = ""
        var work = ""
        if(phone.substr(0,2) == "07")
            mobile=phone
        else
            home = phone

        if(phone2 > "") {
            if(phone2.substr(0,2) == "07" && mobile == "")
                mobile=phone2
            else if(phone2.substr(0,2) == "07" && mobile > "")
                work = phone2
            else if(home == "")
                home = phone2
        }

        var conservation_area = state.conservation_area
        var listed_property = state.listed_property
        let zone = ""
        if(typeof panelArrays !== "undefined" && typeof panelArrays[0] !== "undefined"  && typeof panelArrays[0].zone !== "undefined")
             zone = panelArrays[0].zone

        var pitched_roof = false
        var flat_roof = false
        var ground_mount = false
        var tg_qty = 0
        var se_qty = 0
        var qty_flat_tubs = 0
        var qty_ground_tubs = 0
        let iextra = 2;
        let scaff_sides = 1

        for(var pl=0; pl<panelArrays.length; pl++) {
            var loc = ""
            var np = parseInt(panelArrays[pl].numPanels)
            if(typeof panelArrays[pl].installation_location.description !== "undefined")
                loc = panelArrays[pl].installation_location.description

            if(panelArrays[pl].installation_location.flatroof??false) {
                flat_roof=true
                qty_flat_tubs += np
            }

            if(panelArrays[pl].installation_location.groundmount??false){
                ground_mount=true
                qty_ground_tubs += parseInt(panelArrays[pl].numPanels)
            }

            if(loc.search("Pitched") >=0)  pitched_roof=true

            if(loc == "Roof Recessed (New Roof)" )
                qty_integration_trays_new += np

            if(loc == "Roof Recessed (Existing Roof)" )
                qty_integration_trays_exs += np

            if(loc == "Roof Recessed (Existing Roof Stripped)") 
                qty_integration_trays_exs_stripped += np


            if(typeof panelArrays[pl].optimiser !== "undefined" && panelArrays[pl].optimiser.type == 'TG') tg_qty+=parseInt(panelArrays[pl].qty_optimisers)
            if(typeof panelArrays[pl].optimiser !== "undefined" && panelArrays[pl].optimiser.type == 'SE') se_qty+=parseInt(panelArrays[pl].qty_optimisers)

        } 

        
        if(conservation_area=="") conservation_area = "No"
        if(listed_property == "") listed_property = "No"
        var address = flg.address
        if(flg.address2 > "" ) address += (", " + flg.address2)
        if(flg.towncity > "" ) address += (", " + flg.towncity)
        if(flg.postcode > "" ) address += (", " + flg.postcode)
        var dno_name = flg.fullname > "" ? flg.fullname.toString().toUpperCase() : "CUSTOMER"
        var datap = [
            {pdf: 'flg_id', data: flg_id, type: 'text', font: 'Arial'},
            {pdf: 'order_date', data: order_date, type: 'text', font: 'Arial' },
            {pdf: 'customer_name', data: flg.fullname, type: 'text', font: 'Arial'},
            {pdf: 'c1_forename', data: flg.firstname, type: 'text', font: 'Arial'},
            {pdf: 'c1_surname', data: flg.lastname, type: 'text', font: 'Arial'},
            {pdf: 'cof_email', data: flg.email, type: 'text', font: 'Arial'},
            {pdf: 'consultant_name', data: flg.username, type: 'text', font: 'Arial'},
            {pdf: 'addr1', data: flg.address, type: 'text', font: 'Arial' },
            {pdf: 'addr2', data: flg.address2, type: 'text', font: 'Arial'},
            {pdf: 'county', data: flg.towncity, type: 'text' , font: 'Arial'},
            {pdf: 'postcode', data: flg.postcode, format: 'Uppercase', type: 'text' , font: 'Arial'},
            {pdf: 'latlng', data: flg.data47},
            {pdf: 'dno_address', data: address, type: 'text', font: 'Arial' },
            {pdf: 'dno_name', data: dno_name, type: 'text', font: 'Arial' },
            {pdf: 'conservation_area', data: conservation_area == "Yes" ? true : false, type: 'checkbox', font: 'Arial', check: conservation_area == "Yes" ? true : false},
            {pdf: 'listed_property', data: listed_property == "Yes" ? true : false, type: 'checkbox', font: 'Arial', check: listed_property == "Yes" ? true : false },
            {pdf: 'pitched_roof', data: pitched_roof, type: 'checkbox', check: pitched_roof, font: 'Arial'},
            {pdf: 'flat_roof', data: flat_roof, type: 'checkbox', check: flat_roof, font: 'Arial' },
            {pdf: 'ground_mount', data: ground_mount, type: 'checkbox',check: ground_mount, font: 'Arial' },
            {pdf: 'qty_groundmounts', data: qty_ground_tubs==0 ? '' : qty_ground_tubs, type: 'text', font: 'Arial'},
            {pdf: 'qty_flatroofmounts', data: qty_flat_tubs==0 ? '' : qty_flat_tubs, type: 'text', font: 'Arial'},
            {pdf: 'zone', data: zone, type: 'text', font: 'Arial'}
        ]
        let c2_title = state.customer2title
        let c1_title = flg.title
        if(c1_title == "") c1_title = "N/A"
        if(c2_title == "") c2_title = "N/A"

        datap.push({pdf: 'c1_title', data: c1_title, type: 'dropdown', font: 'Arial'})
        datap.push({pdf: 'c2_title', data: c2_title, type: 'dropdown', font: 'Arial'})
        
        if(state.customer2name > "")
            datap.push({pdf: 'c2_forename', data: state.customer2name, type: 'text', font: 'Arial'})
        if(state.customer2surname > "")
            datap.push({pdf: 'c2_surname', data: state.customer2surname, type: 'text', font: 'Arial'})


        panels =  await GetPanels()

        if((qty_ground_tubs + qty_flat_tubs) == 0) {
            datap.push({pdf: 'included_mounts', data: false, type: 'checkbox',check: false, font: 'Arial' })
            datap.push({pdf: 'qty_mounts', data: '', type: 'text', font: 'Arial'})

        }else {
            datap.push({pdf: 'included_mounts', data: true, type: 'checkbox',check: true, font: 'Arial' })
            datap.push({pdf: 'qty_mounts', data: (qty_ground_tubs + qty_flat_tubs), type: 'text', font: 'ArialBold'})

        }

        datap.push({pdf: 'mobile_phone', data: mobile, type: 'text' , font: 'Arial'})
        datap.push({pdf: 'home_phone', data: home, type: 'text' , font: 'Arial'})
        datap.push({pdf: 'work_phone', data: work, type: 'text' , font: 'Arial'})
        datap.push({pdf: 'se_qty', data: se_qty == 0 ? "" : se_qty, type: 'text' , font: 'Arial'})
        datap.push({pdf: 'tigo_qty', data: tg_qty == 0 ? "" : tg_qty, type: 'text' , font: 'Arial'})
        
        var totwatts = 0
        var gtotal = 0
        for(var pl=0; pl<panelArrays.length; pl++) {
            if(pl < 4) {
                const pa = panelArrays[pl];
                const watts = (pa.numPanels * pa.watts)/1000
                const irradiance = pa.irradiance
                const orientation = pa.orientation
                const pitch = pa.roofPitch
                const sf=pa.shading
                const watttext = "kWpRow" + (pl+1)
                const orrtext = "ORIENTATIONRow" + (pl+1)
                const pitchtext = "INCLINATIONRow" + (pl+1)
                const irradtext = "KkRow" + (pl+1)
                const shadetext = "SFRow"  + (pl+1)
                const arrtext = "ARRAYRow" + (pl+1)
                const tottext = "TotalRow" + (pl+1)
                const tot = Math.round(sf * watts * irradiance)
                gtotal += tot
                totwatts += watts
                datap.push({pdf: arrtext, data: (pl+1), type: 'text', font: "ArialBold" })
                datap.push({pdf: watttext, data: watts, type: 'text', font: "ArialBold"})
                datap.push({pdf: orrtext, data: orientation, type: 'text', font: "ArialBold"})
                datap.push({pdf: pitchtext, data: pitch, type: 'text' , font: "ArialBold"})
                datap.push({pdf: irradtext, data: irradiance, type: 'text' , font: "ArialBold"})
                datap.push({pdf: shadetext, data: sf, type: 'text' , font: "ArialBold"})
                datap.push({pdf: tottext, data: tot, type: 'text', font: "ArialBold" })
            }
        }
        for(var pl=panelArrays.length+1; pl<=4; pl++) {
            const watttext = "kWpRow" + pl
            const orrtext = "ORIENTATIONRow" + pl
            const pitchtext = "INCLINATIONRow" + pl
            const irradtext = "KkRow" + pl
            const shadetext = "SFRow"  + pl
            const arrtext = "ARRAYRow" + pl
            const tottext = "TotalRow" +  pl
            datap.push({pdf: arrtext, data: '', type: 'text', font: "ArialBold" })
            datap.push({pdf: watttext, data: '', type: 'text', font: "ArialBold"})
            datap.push({pdf: orrtext, data: '', type: 'text', font: "ArialBold"})
            datap.push({pdf: pitchtext, data: '', type: 'text' , font: "ArialBold"})
            datap.push({pdf: irradtext, data: '', type: 'text' , font: "ArialBold"})
            datap.push({pdf: shadetext, data: '', type: 'text' , font: "ArialBold"})
            datap.push({pdf: tottext, data: '', type: 'text', font: "ArialBold" })          
        }
        var USAGERow1 = data.savings[0].battery
        if(USAGERow1 > data.savings[0].consumption)
            USAGERow1 = data.savings[0].consumption

        const exportv = Math.round((data.savings[0].smart_export / data.savings[0].solar_production) * 100)
        const usage = Math.round((USAGERow1 / data.savings[0].solar_production) * 100)

        const exportmoney = Number.parseFloat(data.savings[0].smart_export * data.savings[0].export_tariff).toFixed(2)
        const savemoney = Number.parseFloat(USAGERow1 * data.savings[0].oldrate).toFixed(2)
        const twats_rnd = Number.parseFloat(totwatts).toFixed(2)


        datap.push({pdf: "kWpRow5", data: twats_rnd, type: 'text', font: "ArialBold" })
        datap.push({pdf: "TotalRow5", data: gtotal, type: 'text', font: "ArialBold" })
        datap.push({pdf: "PRODUCTIONRow1", data: Math.round(data.savings[0].solar_production), type: 'text', font: "ArialBold" })
        datap.push({pdf: "PRODUCTIONRow1_2", data: Math.round(data.savings[0].solar_production), type: 'text', font: "ArialBold" })
        datap.push({pdf: "USAGERow1", data: Math.round(USAGERow1), type: 'text' , font: "ArialBold"})
        datap.push({pdf: "EXPORTRow1", data: Math.round(data.savings[0].smart_export), type: 'text', font: "ArialBold"})
        datap.push({pdf: "EXPORT", data: exportv + '%', type: 'text' })
        datap.push({pdf: "USAGE", data: usage + '%', type: 'text' })
        datap.push({pdf: "UNITRATERow1", data: data.savings[0].oldrate,type: 'text', font: "ArialBold"})
        datap.push({pdf: "EXPORTRATERow1", data: data.savings[0].export_tariff,type: 'text', font: "ArialBold"})
        datap.push({pdf: "EXPORTTARIFFRow1", data: exportmoney, type: "text", format: "Currency", font: "ArialBold"})
        datap.push({pdf: "ELECSAVINGSRow1", data: savemoney, type: "text", format: "Currency", font: "ArialBold"})
        datap.push({pdf: "elec_usage", data: elecconsumption, type: "text", format: "text", font: "ArialBold"})

        
        const totalsavings = Number.parseFloat(savemoney) + Number.parseFloat(exportmoney)
        datap.push({pdf: "total_output_value", data: Number.parseFloat(totalsavings).toFixed(2), type: "text", format: "Currency", font: "ArialBold" })
        //datap.push({pdf: "total_order_price", data: Number.parseFloat(data.savings[0].systemcost).toFixed(2), type: "text", font: "ArialBold"})
        datap.push({pdf: "total_order_price", data: Number.parseFloat(state.sellprice).toFixed(2), type: "text", font: "ArialBold", alignment: 2, separator: ","})
        datap.push({pdf: "estimated_performance", data: Math.round(data.savings[0].solar_production), type: "text", font: "ArialBold"})
        datap.push({pdf: "num_arrays", numArrays: panelArrays.length})
        // Deal With Soalr Arrays Description
        var ipanels = 0
        var birdprotection_cnt = 0
        var ptypes = []
        var itotwatts = 0
        for(var ip=0; ip<panelArrays.length; ip++) {
            const pan = panelArrays[ip]
            const numPanels = parseInt(pan.numPanels)
            const panelModel = pan.panelModel
            const birdprotection = typeof pan.birdprotection == "undefined" ? false : pan.birdprotection
            const panelWatts = pan.watts
            ipanels += numPanels
            birdprotection_cnt += birdprotection ? numPanels : 0
            itotwatts+=(numPanels * panelWatts)
            var manufacturer = panelModel
            var curp = null            
            var manutotal = panelModel
            if(typeof panels !== "undefined" && panels.length > 0)
                curp = panels.find(x =>x.panel_id === pan.panel_id)
            let extrainfo = ""
            if(curp) {
                manufacturer = curp.manufacturer 
                manutotal = manufacturer + " " + panelWatts + "W"
                extrainfo = curp.extrainfo
            }
            var imatch = false
            for(var it=0; it<ptypes.length; it++)
            {
                if(ptypes[it].panelModel === panelModel) {
                    imatch = true
                    ptypes[it].count+=numPanels
                    break
                }
            }
            if(!imatch)   
                ptypes.push({panelModel: panelModel, count: numPanels, manufacturer,manutotal, extrainfo })
            
            datap.push({
                pdf: "pv_array_" + (ip+1),
                model: panelModel, manufacturer, manutotal, watts: panelWatts,birdprotection, 
                numPanels, 
                installation_location: pan.installation_location.description,
                require_tub: typeof pan.installation_location !== "undefined" ? pan.installation_location.require_tub : "N",
                qty_optimisers: pan.qty_optimisers,
                optimser: typeof pan.optimiser !== "undefined" ? pan.optimiser.description : '',
                optimiser_type: typeof pan.optimiser !== "undefined" ? pan.optimiser.type : ''
            })

        }

        if(typeof state.required_inverters !== "undefined" && state.required_inverters.length > 0) {
            for(var iv=0; iv<state.required_inverters.length; iv++) {
                const inv = state.required_inverters[iv]

                if(inv.inverter.id > 0 ){
                    datap.push({pdf: "inverter_" + (iv+1), model: inv.inverter.description, manufacturer: inv.inverter.manufacturer, watts: inv.inverter.watts, hybrid: inv.inverter.hybrid, itemcode: inv.inverter.itemcode  })
                    if(typeof inv.inverter !== "undefined" && inv.inverter.id >= 0) {
                        if(inv.inverter.hybrid)
                            hybridcnt++
                        else
                            stringcnt++
                        if(inv.offgrid) 
                            offgridcnt++
                        if(inv.is3phase) 
                            offgridcnt++
                    }
                }
            }
        }
        if(hybridcnt+stringcnt > 0) {
            datap.push({pdf: "included_inverters" , data: true, type: "checkbox", font: "Arial",check: true })
        }
        datap.push({pdf:"inverters", hybrid: hybridcnt, string: stringcnt, offgridcnt: offgridcnt, total:  (hybridcnt+ stringcnt)})
        datap.push({pdf: "string_qty" , data: stringcnt, type: "text", font: "Arial" })
        datap.push({pdf: "hybrid_qty" , data: hybridcnt, type: "text", font: "Arial" })
        datap.push({pdf: "qty_inverters" , data: (hybridcnt + stringcnt), type: "text", font: "ArialBold" })


        var typestring = ''
        ptypes.map(item => {
            typestring += typestring ? ", " + item.count + " x " + item.manufacturer : "( " + item.count + " x " + item.manufacturer 
            if(item.extrainfo > "")
                typestring += ` ${item.extrainfo}`
        })
        if(typestring) typestring+=" ) = " + Number.parseFloat((itotwatts/1000)).toFixed(2) + "kW"
        datap.push({pdf: "pv_panels", data: typestring, type: "text", font: "Arial"})
        datap.push({pdf: "qty_solarpv", data: ipanels, type: "text", font: "ArialBold"})
        if(ipanels > 0)
            datap.push({pdf: 'included_solarpv', data: true, type: 'checkbox' , font: 'Arial', check: true})

        if(state.battery && typeof state.battery.description !== "undefined") {
            datap.push({pdf: "battery_storage", data: state.battery.description, type: "text", font: "Arial"})
            datap.push({pdf: "qty_battery", data: state.battery.Qty, type: "text", font: "ArialBold"})
            datap.push({pdf: 'included_battery', data: true, type: 'checkbox' , font: 'Arial', check: true})
        }else {
            datap.push({pdf: "battery_storage", data: '', type: "text", font: "Arial"})
            datap.push({pdf: "qty_battery", data: "", type: "text", font: "ArialBold"})
            datap.push({pdf: 'included_battery', data: false, type: 'checkbox' , font: 'Arial', check: false})    
        }
        if(birdprotection_cnt > 0 ) {
            datap.push({pdf: "qty_birdprevention", data: birdprotection_cnt, type: "text", font: "ArialBold"})
            datap.push({pdf: 'included_birdprevention', data: true, type: 'checkbox' , font: 'Arial', check: true})    
        }else {
            datap.push({pdf: "qty_birdprevention", data: '', type: "text", font: "ArialBold"})
            datap.push({pdf: 'included_birdprevention', data: false, type: 'checkbox' , font: 'Arial', check: false})   
            datap.push({pdf: 'birdprtection_discussed', data: 'Discussed with customer and not required', type: 'text' , font: 'Arial'})   
            
        }

        datap.push({pdf: 'otheropt_qty', data: '', type: 'text' , font: 'Arial'})
        if(se_qty ==0 && tg_qty == 0) {
            datap.push({pdf: 'se_qty', data: '', type: 'text' , font: 'Arial'})
            datap.push({pdf: 'tigo_qty', data: '', type: 'text' , font: 'Arial'})
            datap.push({pdf: 'included_optimisers', data: false, type: 'checkbox',check: false, font: 'Arial' })
            datap.push({pdf: 'qry_optimisers', data: '', type: 'text' , font: 'Arial'})
            datap.push({pdf: 'otheropt_qty', data: '', type: 'text' , font: 'Arial'})
            
        } else {
            datap.push({pdf: 'included_optimisers', data: true, type: 'checkbox',check: true, font: 'Arial' })
            datap.push({pdf: 'qry_optimisers', data: (se_qty + tg_qty), type: 'text' , font: 'ArialBold'})
            datap.push({pdf: 'otheropt_qty', data: '', type: 'text' , font: 'Arial'})
        }

        if(state.softGround > 0 || state.hardGround > 0 ) {
            let qty_ground = 0 
            if(Number(state.softGround) > 0) {
                datap.push({pdf: 'qty_softground', data: state.softGround, type: 'text', font: 'ArialBold'})
                qty_ground += Number(state.softGround)
            }
            if(Number(state.hardGround) > 0) {
                datap.push({pdf: 'qty_hardground', data: state.hardGround, type: 'text', font: 'ArialBold'})
                qty_ground += Number(state.hardGround)
            }
            if(qty_ground > 0) {
                datap.push({pdf: 'qty_grounddig', data: qty_ground, type: 'text', font: 'ArialBold'})
                datap.push({pdf: 'included_softdig', data: true, type: 'checkbox' , font: 'Arial', check: true})
            }
        }
               
        if(state.has_iboost) {
            datap.push({pdf: 'included_iboost', data: true, type: 'checkbox' , font: 'Arial', check: true})
            datap.push({pdf: 'qty_iboost', data: '1', type: 'text' , font: 'ArialBold' })
        }else {
            datap.push({pdf: 'included_iboost', data: false, type: 'checkbox' , font: 'Arial', check: false})
            datap.push({pdf: 'qty_iboost', data: '', type: 'text' , font: 'Arial' })
        }
        
        var maint_type="None"
        if(!state.selected_maintenance || (typeof state.selected_maintenance.description !== "Undefined" && state.selected_maintenance.description == "None")) {
            datap.push({pdf: 'maintenance_type', data: maint_type, type: 'dropdown', font: 'Arial' })
            datap.push({pdf: 'qty_maintenance', data: '', type: 'text' , font: 'Arial' })
            datap.push({pdf: 'included_maintenance', data: false, type: 'checkbox' , font: 'Arial', check: false})           
        }else if( typeof state.selected_maintenance !== "Undefined" && state.selected_maintenance.description != "None") {
            if(state.selected_maintenance.description.substr(0,4) == "Gold") maint_type="Gold"
            if(state.selected_maintenance.description.substr(0,6) == "Bronze") maint_type="Bronze"
            if(state.selected_maintenance.description.substr(0,6) == "Silver") maint_type="Silver"
            datap.push({pdf: 'maintenance_type', data: maint_type, type: 'dropdown', font: 'Arial' })
            datap.push({pdf: 'qty_maintenance', data: '1', type: 'text' , font: 'Arial', })
            datap.push({pdf: 'included_maintenance', data: true, type: 'checkbox' , font: 'Arial', check: true})           
        }


        if(state.has_voltageoptimser) datap.push({pdf: 'qty_vo', data: '1', type: 'text' , font: 'ArialBold' })
        else datap.push({pdf: 'qty_vo', data: '', type: 'text' , font: 'ArialBold', })
        datap.push({pdf: 'included_vo', data: state.has_voltageoptimser, type: 'checkbox' , font: 'Arial', check: state.has_voltageoptimser})
        
        if(state.has_smart_thermostat) datap.push({pdf: 'qty_smartstat', data: '1', type: 'text' , font: 'ArialBold' })
        else datap.push({pdf: 'qty_smartstat', data: '', type: 'text' , font: 'ArialBold' })
        datap.push({pdf: 'included_smartstat', data: state.has_smart_thermostat, type: 'checkbox' , font: 'Arial', check: state.has_smart_thermostat})

        var evchargerdesc = "No EV Charger Required"
        let evcharger_qty = 0
        if(typeof state.evcharger !== "undefined") {
            evchargerdesc = state.evcharger.description
            evcharger_qty = 1
            //datap.push({pdf: "ev_chargerdesc", data: evchargerdesc, type: "text", font: "Arial"})
            if(evchargerdesc == "No EV Charger Required") {
                datap.push({pdf: 'qty_evcharger', data: '', type: 'text' , font: 'ArialBold' })
                datap.push({pdf: 'included_evcharger', data: false, type: 'checkbox' , font: 'Arial', check: false})
                //evcharger_qty = 0
                
            }else {
                datap.push({pdf: 'qty_evcharger', data: evcharger_qty, type: 'text' , font: 'ArialBold' })
                datap.push({pdf: 'included_evcharger', data: true, type: 'checkbox' , font: 'Arial', check: true})
            }
        }
        else {
            //datap.push({pdf: "ev_chargerdesc", data: '', type: "text", font: "Arial"})
            datap.push({pdf: 'qty_evcharger', data: ' ', type: 'text' , font: 'ArialBold' })
            datap.push({pdf: 'included_evcharger', data: false, type: 'checkbox' , font: 'Arial', check: false})
           
        }        
        datap.push({pdf: "ev_chargerdesc", data: evchargerdesc, type: "text", font: "Arial"})

        //datap.push({pdf: 'evcharger', evtype: evchargerdesc})

        var inv_warranty = "5 Year Inverter Warranty"

        if(typeof state.required_inverters !== "undefined" && state.required_inverters.length > 0 && typeof state.required_inverters[0].inverter.manufacturer !== "undefined") {
            switch(state.required_inverters[0].inverter.manufacturer.toUpperCase()) {
                case "ATON" :
                    inv_warranty = "10 Year Aton Inverter Warranty"
                    break;
                case "SOFAR" :
                    inv_warranty = "5 Year Sofar Inverter Warranty"
                    break;
                case "GROWATT" :
                    inv_warranty = "10 Year Growatt Inverter Warranty"
                    break;
                case "SOLAREDGE" :
                        inv_warranty = "12 Year Solaredge Inverter Warranty"
                        break;
                case "GIV ENERGY" :
                    inv_warranty = "5 Year Givenergy Inverter Warranty"
                    break;
                case "HUAWEI" :
                    inv_warranty = "10 Year Huawei Inverter Warranty"
                    break;
                case "GIVENERGY" :
                    inv_warranty = "5 Year Givenergy Inverter Warranty"
                    break;
                case "SOLAX" :
                        inv_warranty = "10 Year Solax Inverter Warranty"
                        break;
                case '':
                    if((state.batteryonly??false) )
                        inv_warranty = '';
        
            }
        }

        var pan_warranty = "25 Year Panel Performance Warranty"
        switch(state.offerid ) {
            case '7 Day Offer 1':
                pan_warranty = "30 Year Panel Performance Warranty"
                break;
            case '7 Day Offer 2':
                inv_warranty =  "20 Year Inverter Warranty"         
                break;
        }

        if((state.batteryonly??false) == false) {
            datap.push({pdf: 'panel_warranty', model: pan_warranty})
            datap.push({pdf: `extra${iextra}` , data: pan_warranty, type: "text", font: "Arial" })
            datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: `qty_extra${iextra}` , data: "1", type: "text", font: "ArialBold" })
            iextra++
        }

        if(inv_warranty > "" ) {
            //datap.push({pdf: 'inv_warranty', model: inv_warranty})
            datap.push({pdf: `extra${iextra}` , data: inv_warranty, type: "text", font: "Arial" })
            datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: `qty_extra${iextra}` , data: "1", type: "text", font: "ArialBold" })
            iextra++
        }

        if((state.batteryonly??false) != true) {
            datap.push({pdf: `extra${iextra}` , data: 'Pre-Installation Survey', type: "text", font: "Arial" })
            datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: `qty_extra${iextra}` , data: "1", type: "text", font: "ArialBold" })
            iextra++
        }
        
        const bat = state.battery 
        // Find Battery data

        if(bat && typeof bat !== "undefined"){
            const found = batterys.find((x) => x._id == bat._id)

            if(found && found.battery_id !== 1 && found.description !== "No Battery") {
                let bat_warranty = `${found.warranty} Year ${titleCase(found.manufacturer)} Battery Warranty `
                if(found.warranty_note > "")
                    bat_warranty += " - " + found.warranty_note

                datap.push({pdf: `extra${iextra}` , data: bat_warranty, type: "text", font: "Arial" })
                datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                datap.push({pdf: `qty_extra${iextra}` , data: "1", type: "text", font: "ArialBold" })
                iextra++
            }
        }



        // Now All of the additional items.
        // First of All Inverter models as this has been asked for multiple times
        for(let il=0; il< state.required_inverters.length; il++) {
            const inv = state.required_inverters[il];
            let strText = ''
            if(inv.offgrid) 
                strText =  `${titleCase(inv.inverter.manufacturer)} ${inv.inverter.description}`
            else if(inv.is3phase) 
                strText = `${titleCase(inv.inverter.manufacturer)} ${inv.inverter.description} (3Phase Inverter)` // ${inv.inverter.description} 
            else if (!inv.inverter.hybrid)
                strText = `${titleCase(inv.inverter.manufacturer)} ${inv.inverter.description} (String Inverter)` // ${inv.inverter.description}
            else {
                if(typeof inv.inverter.highvoltage !== "undefined" && inv.inverter.highvoltage == true)
                    strText = `${titleCase(inv.inverter.manufacturer)} ${inv.inverter.description} (High Voltage Hybrid Inverter)` // ${inv.inverter.description} 
                else
                    strText = `${titleCase(inv.inverter.manufacturer)} ${inv.inverter.description} (Hybrid Inverter)` // ${inv.inverter.description}

            }
            if(inv.inverter.id >=0) {
                datap.push({pdf: `extra${iextra}` , data: strText, type: "text", font: "Arial" })
                datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                datap.push({pdf: `qty_extra${iextra}` , data: "1", type: "text", font: "ArialBold" })
                iextra++
            }
        }
        if(typeof accontroller !== "undefined" && accontroller.item_cost > 0 && accontroller.description > ''  && accontroller.item_id) {
            datap.push({pdf: `extra${iextra}` , data: `AC Charger/Controller - ${accontroller.description}`, type: "text", font: "Arial" })
            datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: `qty_extra${iextra}` , data: 1, type: "text", font: "ArialBold" })
            iextra++

        }

        if((state.batteryonly??false) == false) {
 
            // Output the Panel Fixing Types in Extra Area.
            const panelFixingsLen = state.panelFixings.length
            for(let ip = 0;  ip<panelFixingsLen; ip++) {
                datap.push({pdf: `extra${iextra}` , data: `${state.panelFixings[ip].desc}`, type: "text", font: "Arial" })
                datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                datap.push({pdf: `qty_extra${iextra}` , data: state.panelFixings[ip].count, type: "text", font: "ArialBold" })
                iextra++   
            }
        }      
        
        if((state.batteryonly??false) == false) {
            if(se_qty > 0 ) {

                datap.push({pdf: `extra${iextra}` , data: 'Solaredge CT Clamp', type: "text", font: "Arial" })
                datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                datap.push({pdf: `qty_extra${iextra}` , data: 1, type: "text", font: "ArialBold" })
                iextra++  

                datap.push({pdf: `extra${iextra}` , data: 'Solaredge Modbus', type: "text", font: "Arial" })
                datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                datap.push({pdf: `qty_extra${iextra}` , data: 1, type: "text", font: "ArialBold" })
                iextra++  

                if(bat && typeof bat !== "undefined" && bat.manufacturer.toUpperCase() == "SOLAREDGE") {
                    datap.push({pdf: `extra${iextra}` , data: 'Solaredge NET Kit', type: "text", font: "Arial" })
                    datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                    datap.push({pdf: `qty_extra${iextra}` , data: 1, type: "text", font: "ArialBold" })
                    iextra++            
                }else {
                    datap.push({pdf: `extra${iextra}` , data: 'AC Charger Controller', type: "text", font: "Arial" })
                    datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                    datap.push({pdf: `qty_extra${iextra}` , data: 1, type: "text", font: "ArialBold" })
                    iextra++   
                            
                    datap.push({pdf: `extra${iextra}` , data: 'Solaredge WiFi Kit', type: "text", font: "Arial" })
                    datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                    datap.push({pdf: `qty_extra${iextra}` , data: 1, type: "text", font: "ArialBold" })
                    iextra++   
                }
            }
        }
        datap.push({pdf: `extra${iextra}` , data: '18th Edition IET Wiring Regulations RCD & Surge Protection if required', type: "text", font: "Arial" })
        datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
        datap.push({pdf: `qty_extra${iextra}` , data: 1, type: "text", font: "ArialBold" })
        iextra++ 

        // Now add the following items.
        for(let il=0; il<ancillarycosts.length; il++) {
            const item = ancillarycosts[il]
            if(item.fieldvar > "" && !item.warranty) {
                let found = state.ancillary_items.find((x) => x.key == item.fieldvar)
                let qty = 0
                if(found) {
                    qty = Number(found.value)
                    if(found.key == "scaffolding_sides")
                        scaff_sides+=qty
                }
                if(typeof qty == "undefined" || qty== "" || isNaN(qty)) qty = 0
                if(qty > 0) {
                    datap.push({pdf: `extra${iextra}` , data: item.description, type: "text", font: "Arial" })
                    datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
                    datap.push({pdf: `qty_extra${iextra}` , data: qty, type: "text", font: "ArialBold" })
                    iextra++
                }
               
            }
        }

        if(typeof state.limiterRequired !== "undefined" && state.limiterRequired ) {
            datap.push({pdf: `extra${iextra}` , data: "Grid Export Limiter Device (Where required)", type: "text", font: "Arial" })
            datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: `qty_extra${iextra}` , data: 1, type: "text", font: "ArialBold" })
            iextra++

        }

        if(state.extra_order_info > "") {
            datap.push({pdf: 'extra_final' , data: state.extra_order_info, type: "text", font: "Arial" })
            datap.push({pdf: 'included_extra_final' , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: 'qty_extra_final' , data: '', type: "text", font: "ArialBold" })
        }

        datap.push({pdf: 'mpan' , data: state.mpan??'Not Supplied', type: "text", font: "Arial" })

        // Code added for Scaff Prices - Remove Comments to re-use the data.
        // iextra++
        // datap.push({pdf: `extra${iextra}` , data: `Access Equipment cost allowance £${nf(scaff_sides * pdf_config.scaff_perside,2)}`, type: "text", font: "Arial" })
        // datap.push({pdf: `included_extra${iextra}` , data: true, type: "checkbox", font: "ArialBold",check: true })
        // datap.push({pdf: `qty_extra${iextra}` , data: '', type: "text", font: "ArialBold" })
        // iextra++

        // Add the Deposit amount
        let deposit_amount = typeof state.deposit_amount !== "undefined" ?  Number.parseFloat(state.deposit_amount,2).toFixed(2) : 0.00
        datap.push({pdf: 'deposit_inc_vat', data: deposit_amount, type: "text", font: "ArialBold", alignment: 2, separator: "," })
        let paymentmethod = "Cash"
        if(state.financeoption && typeof state.financeoption.description !== "undefined" && state.financeoption.description != "Cash") {
            paymentmethod="Finance"
            let monthly_payment = (state.fin_monthlypayment * 1).toFixed(2)
            datap.push({pdf: 'fin_common_ques', data: true, type: "checkbox", font: "ArialBold", check: true })
            datap.push({pdf: 'fin_pre_contract', data: true, type: "checkbox", font: "ArialBold", check: true })
            datap.push({pdf: 'fin_sum_loan_agreement', data: true, type: "checkbox", font: "ArialBold", check: true })
            datap.push({pdf: 'fin_num_payments', data: (state.financeterm+1) * 12 , type: "text", font: "Arial" })
            datap.push({pdf: 'fin_monthly_payment', data: monthly_payment, type: "text", font: "Arial" })
            datap.push({pdf: 'fin_max_amount', data: state.fin_totalcost, type: "text", font: "Arial" })
        }
        datap.push({pdf: 'Dropdown3', data: paymentmethod, type: "dropdown", font: "ArialBold" })

        let final_payment_amount = Number.parseFloat(state.sellprice - deposit_amount).toFixed(2)
        datap.push({pdf: 'final_payment_amount', data: final_payment_amount, type: "text", font: "ArialBold", alignment: 2, separator: "," })

        datap.push({pdf: 'vat_rate', data: state.vat, type: "text", font: "ArialBold", alignment: 2, separator: "." })
        //await this.processDatatables(i)
        if((state.propertytype??'Residential') == 'Commercial') {
            datap.push({pdf: `hiesepvs` , data: '2 Year Workmanship Warranty', type: "text", font: "Arial" })
            datap.push({pdf: `included_hies_epvs` , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: `qty_hies` , data: 1, type: "text", font: "ArialBold" })
        } 
        else if((state.batteryonly??false)) {
            datap.push({pdf: `hiesepvs` , data: 'HIES 10 Year Warranty for Maximum Consumer Protection', type: "text", font: "Arial" })
            datap.push({pdf: `included_hies_epvs` , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: `qty_hies` , data: 1, type: "text", font: "ArialBold" })

        }
        else {
            datap.push({pdf: `hiesepvs` , data: 'EPVS Validation & Certification of Your Savings & HIES 10 Year Warranty for\nMaximum Consumer Protection ', type: "text", font: "Arial" })
            datap.push({pdf: `included_hies_epvs` , data: true, type: "checkbox", font: "ArialBold",check: true })
            datap.push({pdf: `qty_hies` , data: 1, type: "text", font: "ArialBold" })
        }
        //console.log(`about to call APIMergeOrderForm offgrid_system = ${state.offgrid_system}`)
        await APIMergeOrderForm(flg_id,datap, filelist, state.noratedisclaimer, state.batteryonly, state.offgrid_system)
        return datap
}

 const titleCase = (strIn) => {
    if(strIn == "" || typeof strIn == "undefined" || !strIn) return strIn
    let word = `${strIn.substring(0,1).toUpperCase()}${strIn.substring(1).toLowerCase()}`
    return word;
}